import React from "react";

import {Text} from "@pg-design/text-module";

import {AdditionalAreaType} from "../../property/utils/get_additional_area_type";
import {KitchenType} from "../../property_configurator/types/KitchenType";
import {ConstructionEndDateType} from "../types/ConstructionEndDateType";
import {ForYouFloorChoiceType} from "../types/ForYouFloorChoiceType";

const optionLabel = (text: string) => {
    return <Text variant="info_txt_1">{text}</Text>;
};

export const additionalAreasOptions = [
    {value: AdditionalAreaType.BALCONY.toString(), labelContent: optionLabel("Balkon")},
    {value: AdditionalAreaType.TERRACE.toString(), labelContent: optionLabel("Taras")},
    {value: AdditionalAreaType.GARDEN.toString(), labelContent: optionLabel("Ogródek")},
    {value: "0", labelContent: optionLabel("Bez znaczenia")}
];

export const kitchenOptions = [
    {value: KitchenType.KITCHENETTE, labelContent: optionLabel("Aneks kuchenny")},
    {value: KitchenType.CLOSED, labelContent: optionLabel("Oddzielna kuchnia")},
    {value: "", labelContent: optionLabel("Bez znaczenia")}
];

export const dateOptions = [
    {value: ConstructionEndDateType.READY.toString(), labelContent: optionLabel("Gotowe")},
    {value: ConstructionEndDateType.THREE_MONTHS.toString(), labelContent: optionLabel("Do 3 miesięcy")},
    {value: ConstructionEndDateType.SIX_MONTHS.toString(), labelContent: optionLabel("Do 6 miesięcy")},
    {value: ConstructionEndDateType.YEAR.toString(), labelContent: optionLabel("Do roku")},
    {value: ConstructionEndDateType.TWO_YEARS.toString(), labelContent: optionLabel("Do 2 lat")},
    {value: ConstructionEndDateType.THREE_YEARS.toString(), labelContent: optionLabel("Do 3 lat")},
    {value: "", labelContent: optionLabel("Bez znaczenia")}
];

export const floorOptions = [
    {value: ForYouFloorChoiceType.GROUND.toString(), labelContent: optionLabel("Parter")},
    {value: ForYouFloorChoiceType.LOW.toString(), labelContent: optionLabel("Niskie piętra (1-4)")},
    {value: ForYouFloorChoiceType.HIGH.toString(), labelContent: optionLabel("Wysokie piętra (5+)")},
    {value: ForYouFloorChoiceType.TOP.toString(), labelContent: optionLabel("Ostatnie piętro")}
];

export const quartersOptions = [
    {value: "3", labelContent: optionLabel("Północ")},
    {value: "4", labelContent: optionLabel("Południe")},
    {value: "1", labelContent: optionLabel("Wschód")},
    {value: "2", labelContent: optionLabel("Zachód")}
];
import React from "react";

import {Text} from "@pg-design/text-module";

import {AdditionalAreaType} from "../../property/utils/get_additional_area_type";
import {KitchenType} from "../../property_configurator/types/KitchenType";
import {ConstructionEndDateType} from "../types/ConstructionEndDateType";
import {ForYouFloorChoiceType} from "../types/ForYouFloorChoiceType";

const optionLabel = (text: string) => {
    return <Text variant="info_txt_1">{text}</Text>;
};

export const additionalAreasOptions = [
    {value: AdditionalAreaType.BALCONY.toString(), labelContent: optionLabel("Balkon")},
    {value: AdditionalAreaType.TERRACE.toString(), labelContent: optionLabel("Taras")},
    {value: AdditionalAreaType.GARDEN.toString(), labelContent: optionLabel("Ogródek")},
    {value: "0", labelContent: optionLabel("Bez znaczenia")}
];

export const kitchenOptions = [
    {value: KitchenType.KITCHENETTE, labelContent: optionLabel("Aneks kuchenny")},
    {value: KitchenType.CLOSED, labelContent: optionLabel("Oddzielna kuchnia")},
    {value: "", labelContent: optionLabel("Bez znaczenia")}
];

export const dateOptions = [
    {value: ConstructionEndDateType.READY.toString(), labelContent: optionLabel("Gotowe")},
    {value: ConstructionEndDateType.THREE_MONTHS.toString(), labelContent: optionLabel("Do 3 miesięcy")},
    {value: ConstructionEndDateType.SIX_MONTHS.toString(), labelContent: optionLabel("Do 6 miesięcy")},
    {value: ConstructionEndDateType.YEAR.toString(), labelContent: optionLabel("Do roku")},
    {value: ConstructionEndDateType.TWO_YEARS.toString(), labelContent: optionLabel("Do 2 lat")},
    {value: ConstructionEndDateType.THREE_YEARS.toString(), labelContent: optionLabel("Do 3 lat")},
    {value: "", labelContent: optionLabel("Bez znaczenia")}
];

export const floorOptions = [
    {value: ForYouFloorChoiceType.GROUND.toString(), labelContent: optionLabel("Parter")},
    {value: ForYouFloorChoiceType.LOW.toString(), labelContent: optionLabel("Niskie piętra (1-4)")},
    {value: ForYouFloorChoiceType.HIGH.toString(), labelContent: optionLabel("Wysokie piętra (5+)")},
    {value: ForYouFloorChoiceType.TOP.toString(), labelContent: optionLabel("Ostatnie piętro")}
];

export const quartersOptions = [
    {value: "3", labelContent: optionLabel("Północ")},
    {value: "4", labelContent: optionLabel("Południe")},
    {value: "1", labelContent: optionLabel("Wschód")},
    {value: "2", labelContent: optionLabel("Zachód")}
];
